export default (vue) => {
  vue.directive('zoomIn', {
    bind: function(el) {
      const visibility = el.style.visibility;
      el.style.visibility = 'hidden';
      let lazyImageObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          let lazyImage = entry.target;
            // 相交率，默认是相对于浏览器视窗
          if(entry.intersectionRatio > 0) {
            // 添加由小变大的动画
            lazyImage.classList.add('animate__animated')
            lazyImage.classList.add('animate__zoomIn')
            setTimeout(() => {
              el.style.visibility = visibility
            }, 0)
            // 当前图片加载完之后需要去掉监听
            lazyImageObserver.unobserve(lazyImage);
          }
        })
      })
      lazyImageObserver.observe(el);
    }
  })
}